<section class="bg-platinum text-white py-16 sm:py-20">
  <div class="mx-auto max-w-4xl px-6 lg:px-8 text-center">
    
    <div class="flex justify-center">
        <img src="https://imgix.cosmicjs.com/afee6120-5a89-11f0-ae5a-0f56aa053fcd-git-branch-plus.svg" alt="icon" width="64" height="64">
    </div>

    <h2 class="text-3xl font-bold tracking-tight sm:text-4xl mt-8">
      What's next for <span class="text-turquoise">Dimers Platinum?</span>
    </h2>

    <p class="mt-6 text-base leading-8 text-gray-300">
        Dimers Platinum started with college football—but it won’t stop there.
    </p>
    <p class="mt-4 text-base leading-8 text-gray-300">
      Our team is already exploring expansion into new sports and market types. This platform is built to grow. By joining now, you'll be first in line for future releases and new AI sports betting tools.
    </p>
    <p class="mt-4 text-base leading-8 text-turquoise">
      Stay close. Big things are coming.
    </p>
  </div>
</section>

<!-- <div class="bg-platinum px-6">
  <div class="max-w-5xl mx-auto h-px bg-white/10"></div>
</div> -->

<section class="bg-platinum py-16 sm:py-20">
  <div class="mx-auto max-w-5xl px-5">
    <div class="flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-10">
      
      <div class="flex-shrink-0 w-64 h-64">
          <img class="rounded-3xl" src="https://imgix.cosmicjs.com/07602890-5ba1-11f0-9566-03ee67f5324b-julesmu_Outlined_vector-style_icon_of_a_rocket_launching_from_d8720015-55c9-47de-b271-744bef671e60_0.gif?auto=format,compress&w=300" alt="image" width="256" height="256" loading="lazy">
      </div>

      <div class="text-center lg:text-left">
        <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Your <span class="text-turquoise">edge</span> starts here
        </h2>
        <p class="mt-6 text-lg leading-8 text-gray-300">
          Don't settle for vibes, group chats or spreadsheets. Dimers Platinum is a proven, profitable and battle-tested AI betting model built for one thing: helping you win.
        </p>
        <p class="mt-4 text-lg leading-8 text-gray-300">
          Join the bettors already using AI to win—because AI football predictions aren't the future. They're already here.
        </p>
        <div class="mt-8">
          <button (click)="jumpToSection('pricing')" class="rounded-md bg-turquoise px-5 py-3 text-base font-semibold text-black shadow-sm hover:bg-cyan-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400">
            Get AI Picks
          </button>
        </div>
      </div>

    </div>
  </div>
</section>